import angular from 'angular';

document.write(require('./view.html').default);
import './style.scss';

angular.module("merchant.application.module.order.cashAppPay", []).controller("merchant.application.module.order.cashAppPay.controller", [
    "$scope", "$controller", "core.application.main.factory.feature",
    function ($scope, $controller, Feature) {
        $controller("merchant.application.module.controller", {$scope: $scope});

        Feature.retrieveFeatureFlagPromise("display-cash-app-pay-order-details", false)
            .then(function (value) {
                $scope.displayCashAppPay = value;
                $scope.$apply();
            });
    }
]);
